var render = function () {
  var _vm$dataModel, _vm$dataModel2, _vm$dataModel2$wizard;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "page-title-header"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": _vm.breadcrumbParentRoute,
      "extra-items": _vm.breadcrumbExtraItems
    }
  })], 1), _c('div', {
    staticClass: "email-wrapper wrapper"
  }, [_c('div', {
    staticClass: "row bg-white"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "preserve-spacing-for-datetime-picker"
  }, [_c('h4', {
    staticClass: "mb-2 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.pageTitle) + " ")]), _vm.isOneTimeBooking ? _c('b-form-group', {
    attrs: {
      "label": "預約號碼",
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-lg": "9"
    }
  }, [_c('label', {
    staticClass: "col-form-label",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_vm._v(_vm._s(_vm.booking.booking_number))])]) : _vm._e(), _c('b-form-group', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": '預約會員',
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-lg": "9"
    }
  }, [_vm.selectedCustomer ? _c('div', {
    staticClass: "d-flex align-items-center py-2 staff-info"
  }, [_c('b-avatar', {
    staticClass: "mx-2",
    attrs: {
      "src": _vm.selectedCustomer.avatar_url
    }
  }), _c('div', {
    staticClass: "mr-auto font-weight-bold text-nowrap text-truncate"
  }, [_vm._v(" " + _vm._s(_vm.selectedCustomer.name) + " "), _c('span', {
    staticClass: "staff-list-info"
  }, [_vm._v(" " + _vm._s(_vm.selectedCustomer.email)), _c('br'), _vm._v(" " + _vm._s(_vm.displayCustomerInfo(_vm.selectedCustomer)) + " ")])])], 1) : _vm._e(), !_vm.isReadOnly ? _c('StaffAddCustomer', {
    ref: "staffAddCustomer",
    attrs: {
      "add-button-text": _vm.addCustomerButtonText,
      "sourceType": 'line'
    },
    on: {
      "bind": _vm.handleSelectCustomer
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "sorted-fields"
  }, [_vm.dataModel.isWizardMode && _vm.dataModel.branchSelectionIsEnabled ? _c('b-form-group', {
    style: {
      order: _vm.fieldOrder.branch
    },
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "分店",
      "label-for": "staff"
    }
  }, [_c('AppSingleSelect', {
    staticClass: "mr-3",
    attrs: {
      "options": _vm.branchOptions,
      "disabled": _vm.isReadOnly || _vm.disabledBranchSelect
    },
    on: {
      "input": _vm.handleBranchChange
    },
    model: {
      value: _vm.booking.select_branch,
      callback: function callback($$v) {
        _vm.$set(_vm.booking, "select_branch", $$v);
      },
      expression: "booking.select_branch"
    }
  })], 1) : _vm._e(), _vm.dataModel.isWizardMode && _vm.dataModel.staffSelectionIsEnabled ? _c('b-form-group', {
    style: {
      order: _vm.fieldOrder.staff
    },
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "員工",
      "label-for": "staff"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_vm.booking.staff ? _c('b-form-text', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0"
  }, [_vm._v(" " + _vm._s(_vm.booking.staff.name) + " ")]) : _vm._e(), !_vm.isReadOnly ? _c('b-button', {
    staticClass: "mb-xl-0",
    attrs: {
      "variant": "primary",
      "disabled": !_vm.booking.branch_id
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.staffSelection.show();
      }
    }
  }, [_vm.isFetchingStaffs ? _c('b-spinner', {
    attrs: {
      "small": ""
    }
  }) : _c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" 選擇員工 ")], 1) : _vm._e()], 1)]) : _vm._e(), _vm.dataModel.isWizardMode && _vm.dataModel.serviceFieldId ? _c('b-form-group', {
    style: {
      order: _vm.fieldOrder.service
    },
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "服務",
      "label-for": "service"
    }
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.isLoadingServices
    }
  }, [_vm.canMultipleSelect ? _c('div', [_c('b-form-checkbox-group', {
    attrs: {
      "options": _vm.serviceOptions,
      "disabled": _vm.isReadOnly
    },
    on: {
      "input": _vm.handleServiceSelected
    },
    model: {
      value: _vm.booking.service_id,
      callback: function callback($$v) {
        _vm.$set(_vm.booking, "service_id", $$v);
      },
      expression: "booking.service_id"
    }
  })], 1) : _c('div', [_c('b-form-radio-group', {
    attrs: {
      "options": _vm.serviceOptions,
      "disabled": _vm.isReadOnly
    },
    on: {
      "input": _vm.handleServiceSelected
    },
    model: {
      value: _vm.booking.service_id,
      callback: function callback($$v) {
        _vm.$set(_vm.booking, "service_id", $$v);
      },
      expression: "booking.service_id"
    }
  })], 1)])], 1) : _vm._e(), _vm.dataModel.isWizardMode && (_vm$dataModel = _vm.dataModel) !== null && _vm$dataModel !== void 0 && _vm$dataModel.serviceFieldId ? _c('b-form-group', {
    style: {
      order: (_vm$dataModel2 = _vm.dataModel) === null || _vm$dataModel2 === void 0 ? void 0 : (_vm$dataModel2$wizard = _vm$dataModel2.wizardFieldOrder) === null || _vm$dataModel2$wizard === void 0 ? void 0 : _vm$dataModel2$wizard.service
    },
    attrs: {
      "label": "服務時長",
      "label-cols": "2"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('span', {
    staticClass: "mr-2"
  }, [_vm._v(_vm._s(_vm.serviceDuration) + " 分鐘")])])]) : _vm._e()], 1), _c('DynamicFormDashboard', {
    ref: "dynamicForm",
    attrs: {
      "input-subjects": _vm.visibleSubjects
    },
    model: {
      value: _vm.inputForm,
      callback: function callback($$v) {
        _vm.inputForm = $$v;
      },
      expression: "inputForm"
    }
  }), false === _vm.hasSetUpFieldMappingForStartAt ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "開始時間",
      "label-for": "start_at"
    }
  }, [_c('AppDateTimePicker', {
    attrs: {
      "id": "start_at",
      "hasError": _vm.deepGet(_vm.v$, 'start_at.$error'),
      "disabled": _vm.isReadOnly
    },
    model: {
      value: _vm.start_at,
      callback: function callback($$v) {
        _vm.start_at = $$v;
      },
      expression: "start_at"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.deepGet(_vm.v$, 'start_at.$error')
    }
  }, [_vm._v(" 輸入的資料有誤或未填寫，請確認 ")])], 1) : _vm._e(), _vm.shouldShowDefaultEndAtField ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "結束時間",
      "label-for": "end_at"
    }
  }, [_c('AppDateTimePicker', {
    attrs: {
      "id": "end_at",
      "hasError": _vm.deepGet(_vm.v$, 'end_at.$error'),
      "disabled": _vm.isReadOnly
    },
    model: {
      value: _vm.end_at,
      callback: function callback($$v) {
        _vm.end_at = $$v;
      },
      expression: "end_at"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.deepGet(_vm.v$, 'end_at.$error')
    }
  }, [_vm._v(" 輸入的資料有誤或未填寫，請確認 ")])], 1) : _vm._e(), _vm.isPeriodicBooking ? [_vm.isEditing ? _c('hr', {
    staticClass: "my-4"
  }) : _vm._e(), _vm.isEditing ? _c('h5', {
    staticClass: "mb-3"
  }, [_vm._v("修改範圍")]) : _vm._e(), _vm.isEditing ? _c('b-form-group', [_c('b-form-radio-group', {
    model: {
      value: _vm.scope,
      callback: function callback($$v) {
        _vm.scope = $$v;
      },
      expression: "scope"
    }
  }, [_c('label', {
    staticClass: "mutation-scope"
  }, [_c('b-form-radio', {
    attrs: {
      "value": "this"
    }
  }, [_c('div', [_c('strong', [_vm._v("這次預約")]), _c('p', {
    staticClass: "mutation-scope__note"
  }, [_vm._v("只修改選定日期的預約")])])])], 1), _c('label', {
    staticClass: "mutation-scope"
  }, [_c('b-form-radio', {
    attrs: {
      "value": "future"
    }
  }, [_c('div', [_c('strong', [_vm._v("這次預約與後續預約")]), _c('p', {
    staticClass: "mutation-scope__note"
  }, [_vm._v("修改選定日期及之後的所有預約")])])])], 1), _c('label', {
    staticClass: "mutation-scope",
    class: {
      disabled: _vm.startAtDateIsChanged
    }
  }, [_c('b-form-radio', {
    attrs: {
      "value": "all",
      "disabled": _vm.startAtDateIsChanged
    }
  }, [_c('div', [_c('strong', [_vm._v("所有預約")]), _vm.startAtDateIsChanged ? _c('p', {
    staticClass: "mutation-scope__note text-danger"
  }, [_vm._v("開始日期已變更，無法套用至所有預約")]) : _c('p', {
    staticClass: "mutation-scope__note"
  }, [_vm._v("修改此週期性預約所有尚未開始的預約記錄")])])])], 1)])], 1) : _vm._e(), _vm.isEditing && _vm.scope !== 'this' || !_vm.isEditing ? [_c('hr', {
    staticClass: "my-4"
  }), _c('h5', {
    staticClass: "mb-3"
  }, [_vm._v("重複模式")]), _c('b-form-group', {
    attrs: {
      "label": "重複頻率",
      "label-cols": "2"
    }
  }, [_c('b-form-radio-group', {
    on: {
      "change": _vm.handleRecurrenceTypeChange
    },
    model: {
      value: _vm.periodicConfig.period_type,
      callback: function callback($$v) {
        _vm.$set(_vm.periodicConfig, "period_type", $$v);
      },
      expression: "periodicConfig.period_type"
    }
  }, [_c('b-form-radio', {
    attrs: {
      "value": "daily"
    }
  }, [_vm._v("每天")]), _c('b-form-radio', {
    attrs: {
      "value": "weekly"
    }
  }, [_vm._v("每週")]), _c('b-form-radio', {
    attrs: {
      "value": "monthly"
    }
  }, [_vm._v("每月")])], 1)], 1), _c('b-form-group', {
    attrs: {
      "label": "間隔",
      "label-cols": "2"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "placeholder": "\u6BCF N ".concat(_vm.intervalUnit)
    },
    model: {
      value: _vm.periodicConfig.period_interval,
      callback: function callback($$v) {
        _vm.$set(_vm.periodicConfig, "period_interval", _vm._n($$v));
      },
      expression: "periodicConfig.period_interval"
    }
  })], 1), _vm.periodicConfig.period_type === 'weekly' ? _c('b-form-group', {
    attrs: {
      "label": "星期",
      "label-cols": "2"
    }
  }, [_c('b-form-select', {
    model: {
      value: _vm.periodicConfig.period_day_of_week,
      callback: function callback($$v) {
        _vm.$set(_vm.periodicConfig, "period_day_of_week", $$v);
      },
      expression: "periodicConfig.period_day_of_week"
    }
  }, [_c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("星期日")]), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("星期一")]), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("星期二")]), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("星期三")]), _c('option', {
    domProps: {
      "value": 4
    }
  }, [_vm._v("星期四")]), _c('option', {
    domProps: {
      "value": 5
    }
  }, [_vm._v("星期五")]), _c('option', {
    domProps: {
      "value": 6
    }
  }, [_vm._v("星期六")])])], 1) : _vm._e(), _vm.periodicConfig.period_type === 'monthly' ? _c('b-form-group', {
    attrs: {
      "label": "日期",
      "label-cols": "2"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "placeholder": "1~31"
    },
    model: {
      value: _vm.periodicConfig.period_day_of_month,
      callback: function callback($$v) {
        _vm.$set(_vm.periodicConfig, "period_day_of_month", _vm._n($$v));
      },
      expression: "periodicConfig.period_day_of_month"
    }
  })], 1) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label": "結束日期",
      "label-cols": "2"
    }
  }, [_c('b-form-radio-group', {
    model: {
      value: _vm.lastBookingDateMode,
      callback: function callback($$v) {
        _vm.lastBookingDateMode = $$v;
      },
      expression: "lastBookingDateMode"
    }
  }, [_c('div', {
    staticClass: "d-inline-flex align-items-center"
  }, [_c('b-form-radio', {
    attrs: {
      "value": null
    }
  }, [_vm._v("持續不停")]), _c('div', {
    staticClass: "d-inline-flex align-items-center"
  }, [_c('b-form-radio', {
    staticClass: "mr-0",
    attrs: {
      "value": "specified"
    }
  }), _vm._v(" 於 "), _c('AppDatePicker', {
    staticClass: "ml-2",
    model: {
      value: _vm.lastBookingDate,
      callback: function callback($$v) {
        _vm.lastBookingDate = $$v;
      },
      expression: "lastBookingDate"
    }
  })], 1)], 1)])], 1)] : _vm._e(), _c('hr', {
    staticClass: "my-4"
  }), _c('h5', {
    staticClass: "mb-3"
  }, [_vm._v("預覽")]), _vm.previewDates.length ? _c('div', {
    staticClass: "mt-3"
  }, [_c('h6', [_vm._v("接下來的預約：")]), _c('ul', {
    staticClass: "list-unstyled"
  }, _vm._l(_vm.previewDates, function (dateRange, index) {
    return _c('li', {
      key: index,
      staticClass: "mb-1"
    }, [_c('i', {
      staticClass: "fa fa-calendar text-primary"
    }), dateRange.end ? _c('span', [_vm._v(" " + _vm._s(_vm.formatDate(dateRange.start)) + " ~ " + _vm._s(_vm.formatDate(dateRange.end)) + " ")]) : _c('span', [_vm._v(" " + _vm._s(_vm.formatDate(dateRange.start)) + " ")])]);
  }), 0)]) : _c('div', {
    staticClass: "text-muted"
  }, [_c('p', [_vm._v("請填寫開始時間和週期設定以預覽預約")])])] : _vm._e(), _c('div', {
    staticClass: "d-flex justify-content-center mt-4"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 返回 ")]), !_vm.isReadOnly ? _c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" 儲存 ")]) : _vm._e()], 1)], 2)])], 1)], 1)])]), _c('StaffSelectionModal', {
    ref: "staffSelection",
    attrs: {
      "staffs": _vm.availableStaffs,
      "is-loading": _vm.isFetchingStaffs
    },
    on: {
      "selected": _vm.handleStaffSelected
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }